import React, {useEffect, useState} from "react";
import {getProductByCategories,getProductByCategories_v1} from "../../service/myProductService";
import { ItemDefaultV2 } from "../Products/Item";


const BoxProduct =({uri})=>{
    const [data, setData] = useState([]);
    const loadProductOnCategory=()=>{
        try{
            // getProductByCategories(0, 8, uri).then((response)=>{
                getProductByCategories_v1(0, 8, uri,  '', '', 0, 100000000).then((response)=>{
            if(+response.status===200){
              setData(response.message);       
            }
          });
        }catch(e){console.log(e)}
      }
    useEffect(()=>{
        loadProductOnCategory();
    },[]);

    return(
        <div className="col-9 p-0" style={{width:880}}>
            <div className="row row-gap-3 m-0">
                <div className="col-12 p-0">
                    <div className="row m-0 product--gift">
                        {
                            data.map((item, index)=>{
                                return <div key={index} className="col-3 mb-2">
                                <ItemDefaultV2 item={item} index={index} showPriceRow='true' showpercen='false'/>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BoxProduct;